import React from "react";

import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  useBreakpointValue,
  UseModalProps,
} from "@chakra-ui/react";

import { mobileStyleBreakpoint } from "util/styleHelpers";
import BackToTopProvider from "contexts/BackToTopProvider";
import { CardProps } from "components/Card";
import ContractDetailsCard from "./ContractDetailsCard";

const drawerPaddingX = mobileStyleBreakpoint(4, 0);
const drawerSize = mobileStyleBreakpoint("full", "xl", "md");

const ContractDetailsDrawer = ({
  isOpen = false,
  onClose = () => {
    return;
  },
  ...rest
}: Partial<UseModalProps> & CardProps): React.ReactElement => {
  const size = useBreakpointValue(drawerSize);

  return (
    <Drawer isOpen={isOpen} onClose={onClose} size={size}>
      <DrawerOverlay />
      <DrawerContent maxHeight="100%">
        <DrawerBody px={drawerPaddingX}>
          <BackToTopProvider>
            <ContractDetailsCard onClose={onClose} {...rest} height="100%" />
          </BackToTopProvider>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default ContractDetailsDrawer;
